import { render, staticRenderFns } from "./DateSeparator.vue?vue&type=template&id=7f15f54c&scoped=true&"
import script from "./DateSeparator.vue?vue&type=script&lang=js&"
export * from "./DateSeparator.vue?vue&type=script&lang=js&"
import style0 from "./DateSeparator.vue?vue&type=style&index=0&id=7f15f54c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f15f54c",
  null
  
)

export default component.exports